<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.DIALOG.ESIM_REQUESTED"
    :handler="(data) => showEsimDialog(data)"
  />
</template>

<script setup>
import { onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';

const { proxy } = getCurrentInstance();
const { $constants } = proxy;
const router = useRouter();

let currentResolve = null;
let currentReject = null;

onMounted(async () => {
  // Expose dialog globally
  window.esimDialog = showEsimDialog;
});

onBeforeUnmount(() => {
  if (window.esimDialog === showEsimDialog) {
    delete window.esimDialog;
  }
});

function showEsimDialog(config = {}) {
  return new Promise((resolve, reject) => {
    currentResolve = resolve;
    currentReject = reject;

    // Simply redirect to /esim page
    // The country is selected globally via the header selector
    router.push('/esim');

    // Resolve immediately - the user will select packages on the /esim page
    resolve({ accepted: false });
  });
}
</script>
